/**
 * Configuración del menú lateral (sidebar).
 *
 * Cada item declara:
 * - key: identificador único
 * - label: texto visible
 * - icon: nombre del Material Symbol
 * - path: ruta absoluta dentro de la app
 * - permissionCode (opcional): si se setea, el item se filtra por permisos del usuario
 * - module (opcional): agrupación para el header de sección
 */
export type MenuItem = {
  key: string;
  label: string;
  icon: string;
  path: string;
  permissionCode?: string;
  module?: string;
};

export const menuSections: { module: string; title: string; items: MenuItem[] }[] = [
  {
    module: 'general',
    title: 'General',
    items: [
      { key: 'dashboard', label: 'Dashboard', icon: 'space_dashboard', path: '/app/dashboard', module: 'general' },
    ],
  },
  {
    module: 'admin',
    title: 'Administración',
    items: [
      { key: 'tenants', label: 'Tenants', icon: 'apartment', path: '/app/tenants', permissionCode: 'tenants.view', module: 'admin' },
      { key: 'users', label: 'Usuarios', icon: 'group', path: '/app/users', permissionCode: 'users.view', module: 'admin' },
      { key: 'audit', label: 'Auditoría', icon: 'history', path: '/app/audit-logs', permissionCode: 'audit_logs.view', module: 'admin' },
    ],
  },
  {
    module: 'operations',
    title: 'Operaciones',
    items: [
      { key: 'documents', label: 'Documentos', icon: 'description', path: '/app/documents', permissionCode: 'documents.view', module: 'operations' },
      { key: 'conversations', label: 'Conversaciones', icon: 'chat', path: '/app/conversations', permissionCode: 'conversations.view', module: 'operations' },
      { key: 'quotations', label: 'Cotizaciones', icon: 'request_quote', path: '/app/quotations', permissionCode: 'quotations.view', module: 'operations' },
      { key: 'suppliers', label: 'Proveedores', icon: 'inventory_2', path: '/app/suppliers', permissionCode: 'suppliers.view', module: 'operations' },
    ],
  },
  {
    module: 'account',
    title: 'Cuenta',
    items: [
      { key: 'profile', label: 'Mi perfil', icon: 'account_circle', path: '/app/profile', module: 'account' },
    ],
  },
];
